export default {
  businessType: 'Business Type',
  searchDate: '时间',
  summary: '总览',
  vendor: '供应商',
  solution: ' 解决方案',
  detail: '明细',
  plant: '仓库',
  cartonUnitAccuracy: '箱&件准确率',
  giedASNQty: 'GIed/ASN 数量 (箱)',
  scannedQty: '扫描数量 (箱)',
  noScan: 'No Scan 数量 (箱)',
  accurate: 'Accurate (箱)',
  scanMissed: 'EPC 少件 (箱)',
  scanExceeded: 'EPC 多件 (箱)',
  misMatched: 'UPC 混件 (箱)',
  byCartonAccuracy: 'By Carton 精确度',
  tunnelException: '通道机异常',
  noReadQty: 'No Read Qty (EPC)',
  noDataQty: 'No Data 数量 (箱)',
  noDataRate: 'No Data 率',
  tunnelMachine: '通道机',
  cartonPE: 'Carton PE',
  dataDefinition: 'Data Definition',
  definition1: `* This report does not include data from Trans Hub or ADC.`,
  definition2: `Carton & Unit Accuracy`,
  definition3: `
    GIed/ASN Qty (Carton): Aggregated GIed or ASN Carton quantity by plant, in carton, based on user selection on business type.
    <br/>
    No Scan (Carton): Aggregated Carton quantity not scanned in tunnel while exist in ASN/GI, in carton.
    <br/>
    Scanned Qty (Carton): Aggregated Carton quantity scanned and recorded via tunnel machine by plant/tunnel machine (by vendor, specifically for 1027 outbound tunnel machine), in carton.
    <br/>
    Accurate (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record, while all UPC quantities are matched, in carton.
    <br/>
    UPC Missed (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record, while scanned UPC quantity is less than the ASN/GI UPC quantity, in carton.
    <br/>
    UPC Exceeded (Carton):  Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record,
    while scanned UPC quantity is greater than the ASN/GI UPC quantity, in carton.
    <br/>
    UPC Mismatched (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN/GI record,
    while scanned UPC does not belong to this Carton Number or does not belong to this ASN, or if the carton does not meet Scan missed/exceeded conditions, in carton.
    <br/>
    By Carton Accuracy = Accurate (Carton) / GIed/ASN Qty (Carton)`,
  definition4: `
Tunnel Exception`,
  definition5: `
    No Data Qty (Carton): Aggregated Carton quantity scanned by tunnel while has no EPC number on it, in carton.
    <br/>
    No Data Rate = No Data Qty (Carton) / GIed/ASN Qty (Carton)`,
  exportExceptions: '导出异常明细',
  multipleErr: '只允许IB–Factory、IB–STO的多选'
}
